import React, { useEffect, useState } from "react";

import { appDoNavegador, enderecoNoChrome, linkParaNavegador, MARCA, sistemaDoCelular, textosDoAviso, tirarMarcaDeVolta } from "utils/navegadorApp";

import { Botao, Caixa, CampoLink, Confirmacao, Continuar, Passo, Passos, Pequeno, Texto, Titulo } from "./styled";

// 📱 12/10/2026: a dica "assine pelo Chrome/Safari" (ver utils/navegadorApp; tom de dica, nunca de alerta). Fica no
// COMEÇO da assinatura (pedido do dono): quem troca de navegador ali não perde nada do que digitou. Só
// aparece no navegador de dentro do Instagram ou do Facebook; em qualquer outro lugar não desenha nada.
// Não obriga: "Continuar aqui mesmo" fecha o aviso (o Pix funciona bem lá dentro).

const navegadorAgora = () => (typeof navigator !== 'undefined' ? navigator : { userAgent: '', maxTouchPoints: 0 });

// Troca o endereço da barra SEM recarregar e sem avisar o roteador (nada na tela muda).
const trocarEndereco = endereco => {
    try { window.history.replaceState(window.history.state, '', endereco); } catch (e) { }
};

// Quem chegou no Chrome ou no Safari pelo aviso: a marca sai do endereço (a contagem já ficou no
// registro do servidor quando a página abriu). As telas chamam isto ao abrir.
export const tirarMarcaDoEndereco = () => {
    try {
        const r = tirarMarcaDeVolta(window.location.href, navegadorAgora().userAgent);
        if (r) trocarEndereco(r.limpo);
    } catch (e) { }
};

const copiarTexto = texto => {
    const jeitoAntigo = () => {
        try {
            const c = document.createElement('textarea');
            c.value = texto;
            c.setAttribute('readonly', '');
            c.style.position = 'fixed';
            c.style.opacity = '0';
            document.body.appendChild(c);
            c.select();
            c.setSelectionRange(0, texto.length);
            const ok = document.execCommand('copy');
            document.body.removeChild(c);
            return ok;
        } catch (e) { return false; }
    };
    if (navigator.clipboard && window.isSecureContext) {
        return navigator.clipboard.writeText(texto).then(() => true, jeitoAntigo);
    }
    return Promise.resolve(jeitoAntigo());
};

// Tenta o Chrome. Se o app barrar o atalho (a página continua na frente depois de 2,5 s), chama aoBarrar.
const tentarChrome = (caminho, aoBarrar) => {
    let relogio = null;
    const saiu = () => { if (document.visibilityState === 'hidden') parar(); };
    const parar = () => { clearTimeout(relogio); document.removeEventListener('visibilitychange', saiu); };
    relogio = setTimeout(() => {
        document.removeEventListener('visibilitychange', saiu);
        if (document.visibilityState === 'visible') aoBarrar();
    }, 2500);
    document.addEventListener('visibilitychange', saiu);
    window.addEventListener('pagehide', parar, { once: true });
    window.location.href = enderecoNoChrome(window.location.host, caminho);
};

export default function AvisoNavegadorApp({ contexto = 'cadastro' }) {
    const nav = navegadorAgora();
    const app = appDoNavegador(nav.userAgent);
    const so = sistemaDoCelular(nav.userAgent, nav.maxTouchPoints);
    const [fechado, setFechado] = useState(false);
    const [barrado, setBarrado] = useState(false);
    const [copia, setCopia] = useState('');

    // A marca vai também no endereço de agora: quem usar o menu do app ("Abrir no navegador externo")
    // chega no Safari ou no Chrome com ela e entra na contagem.
    useEffect(() => {
        if (!app) return;
        try {
            const atual = new URL(window.location.href);
            if (atual.searchParams.get(MARCA) === app) return;
            atual.searchParams.set(MARCA, app);
            trocarEndereco(atual.pathname + atual.search + atual.hash);
        } catch (e) { }
    }, [app]);

    if (!app || fechado) return null;

    const t = textosDoAviso(so, app, contexto);
    const link = linkParaNavegador(window.location.href, app);
    const abrirNoChrome = () => {
        const destino = new URL(link);
        tentarChrome(destino.pathname + destino.search, () => setBarrado(true));
    };
    const copiar = async () => setCopia((await copiarTexto(link)) ? 'copiou' : 'falhou');
    const mostrarPassos = so !== 'android' || barrado;

    return (
        <Caixa role="note" aria-label={t.titulo}>
            <Titulo>{t.titulo}</Titulo>
            <Texto>{t.texto}</Texto>
            {so === 'android' && !barrado ? <Botao onClick={abrirNoChrome}>{t.botao}</Botao> : null}
            {mostrarPassos ? <>
                {barrado ? <Texto>{t.barrado}</Texto> : null}
                <Passos>
                    <Passo>{t.passo1}</Passo>
                    <Passo>{t.passo2}</Passo>
                </Passos>
                <Botao contorno onClick={copiar}>{t.copiar}</Botao>
            </> : null}
            {copia === 'copiou' ? <Confirmacao role="status">{t.copiado}</Confirmacao> : null}
            {copia === 'falhou' ? <>
                <Confirmacao role="status">{t.naoCopiou}</Confirmacao>
                <CampoLink readOnly value={link} aria-label="Link da página" onFocus={e => e.target.select()} />
            </> : null}
            <Pequeno>{t.depois}</Pequeno>
            <Pequeno>{t.pix}</Pequeno>
            <Continuar onClick={() => setFechado(true)}>{t.continuar}</Continuar>
        </Caixa>
    );
}
